import React from "react";
import "./Cards.css";

const Cards = ({ name, image, price }) => {
  return (
    <div className="card">
      <div className="imgBx">
        <img src={image} alt={name} />
      </div>
      <div className="contenido">
        <div className="details">
          <h3>{name}</h3>
          <h3>Price: ${price}</h3>
          <button>Comprar</button>
        </div>
      </div>
    </div>
  );
};

export default Cards;
